/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// jQuery("form[action='/cart/add'] [type=submit]").on("click", function(e) {
//    // Validations here
//  alert($('select[name="id"] option:selected').val());
// //       return false;
// //   e.preventDefault();
// });

jQuery(".Size .SizeSwatch__Radio").on("click", function(e) {
  document.getElementById('hiddenSelectVal1').value = 1;
});

jQuery(".ColorSwatchList .ColorSwatch__Radio").on("click", function(e) {
  var selectColorVal = $('input:radio[name=option-0]:checked').val();
  $('.SizeSwatch__Radio').removeClass('disabled_variant');
  $('input:radio[name=option-1]').each(function(){
    var sizeVal = $(this).val();
    if($('#'+selectColorVal+'-'+sizeVal).val() == '1'){
    	$(this).addClass('disabled_variant');
    }
  });
});

jQuery( document ).ready(function() {
  var selectColorVal = $('.ColorSwatchList input:radio[name=option-0]:checked').val();
  
  if (typeof selectColorVal === "undefined") {
  }
  else{
    $('.SizeSwatch__Radio').removeClass('disabled_variant');
    $('input:radio[name=option-1]').each(function(){
      var sizeVal = $(this).val();
      if($('#'+selectColorVal+'-'+sizeVal).val() == '1'){
          $(this).addClass('disabled_variant');
      }
    });
  }
  var varinatDefaulPrice= jQuery('.mainprice').eq(0).val();
  var dhotiPrice = jQuery('.dhoti-price').eq(0).val();
  dhotiPrice = Math.round(dhotiPrice);
  varinatDefaulPrice=Math.round(varinatDefaulPrice);
  jQuery('.total-size-main').text('Rs.'+varinatDefaulPrice);
  var combinePrice = (parseInt(varinatDefaulPrice)+parseInt(dhotiPrice));
  jQuery('.total-dhoti-main').text('Rs. '+combinePrice);
});

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  if(document.getElementById('hiddenSelectVal1')!=null){
    var hiddenSelectVal1 = document.getElementById('hiddenSelectVal1').value;
    var hiddenSelectVal2 = document.getElementById('hiddenSelectVal2').value;
    
    if(hiddenSelectVal1 == 1){
      if(variant){
        if(variant.available){
            document.getElementById("ProductForm__AddToCart").innerHTML = '<span>Add to Cart</span>'; 
            document.getElementById('ProductForm__AddToCart').disabled = false;
        }
        else{
            document.getElementById("ProductForm__AddToCart").innerHTML = '<span>Sold Out</span>'; 
            document.getElementById('ProductForm__AddToCart').disabled = true;
        }
        document.getElementById("ProductForm__BuyButtons").style.display = "";
        document.getElementById("ProductForm__BuyButtons_pre").style.display = "none";
      }
      else{
        document.getElementById("ProductForm__BuyButtons").style.display = "none";
        document.getElementById("ProductForm__BuyButtons_pre").style.display = "";
      }
    }
  }
});
function unique(array){
    return array.filter(function(el, index, arr) {
        return index === arr.indexOf(el);
    });
}
jQuery('.SizeSwatch__Radio').click(function() {
  if(jQuery(this).hasClass('select-swatch')){
    jQuery(this).removeClass('select-swatch');
  }else{
    jQuery(this).addClass('select-swatch');
  }
  var selectedVariant=selectVariantData();
});
jQuery('.dhoti-increase-quantity').click(function(){
   if(jQuery(this).attr('readonly')==undefined){
     var selectedVariant=selectVariantData();
     calculationPrice();
   }else{
      var id = jQuery(this).prev('.QuantitySelector__CurrentQuantity').attr('id');
      setTimeout(function() {
       jQuery('#'+id).val(0);
      },10);
   }
});
jQuery('.size-increase-quantity').click(function(){
   if(jQuery(this).attr('readonly')==undefined){
     var selectedVariant=selectVariantData();
     calculationPrice();
   }else{
      var id = jQuery(this).prev('.QuantitySelector__CurrentQuantity').attr('id');
      setTimeout(function() {
       jQuery('#'+id).val(0);
      },10);
   }
});
jQuery('.dhoti-decrease-quantity').click(function(){
  var id = jQuery(this).next('.QuantitySelector__CurrentQuantity').attr('id');
  if(jQuery(this).next('.QuantitySelector__CurrentQuantity').val()==1){
    setTimeout(function() {
     jQuery('#'+id).val(0);
     calculationPrice();
    },500);
  }
});
jQuery('.size-decrease-quantity').click(function(){
  var id = jQuery(this).next('.QuantitySelector__CurrentQuantity').attr('id');
  if(jQuery(this).next('.QuantitySelector__CurrentQuantity').val()==1){
    setTimeout(function() {
     jQuery('#'+id).val(0);
     calculationPrice();
    },500);
  }
});
function calculationPrice(){
  var totalSizePrice = 0;
  var totalDhotiPrice = 0;
  setTimeout(function(){
    jQuery('.SizeSwatch__Radio').each(function(){
        var variantId = jQuery(this).attr('variant-id');
        if(jQuery('#qunatity-'+variantId).val()!=0){
          var multiplyPrice = (parseInt(jQuery('#qunatity-'+variantId).val())*parseFloat(jQuery('#price-'+variantId).val().replace(/,/g, '')));
          totalSizePrice+=multiplyPrice;
        }
        if(jQuery('#dhotiqunatity-'+variantId).val()!=0){
          var multiplyDPrice = (parseInt(jQuery('#dhotiqunatity-'+variantId).val())*parseFloat(jQuery('#dhotiprice-'+variantId).val().replace(/,/g, '')));
          var shirtPrice = (parseInt(jQuery('#dhotiqunatity-'+variantId).val())*parseFloat(jQuery('#price-'+variantId).val().replace(/,/g, '')));
          totalDhotiPrice+=(multiplyDPrice+shirtPrice);
        }
    });
    jQuery('.total-size-amt').text('Rs '+parseFloat(totalSizePrice));
    jQuery('.total-dhoti-amt').text('Rs '+parseFloat(totalDhotiPrice));
    if(totalDhotiPrice!=0 || totalSizePrice!=0){
      jQuery('#custom_cartbtn').val('Add To Cart');
    }else{
      jQuery('#custom_cartbtn').val('select size');
    }
  },200);
}
var selectSize=[];
var dhotiSize = [];
var variantId;
function selectVariantData(){
  jQuery('.SizeSwatch__Radio').each(function(){
      var variantId = jQuery(this).attr('variant-id');
      selectSize.push(variantId);
  });
  return selectSize;
}
// Open cart drawer after add to cart button is clicked
jQuery('.product__add-to-cart-button').on('click', function(e){
    if(selectSize.length>0){
      jQuery('.loading').show();
      jQuery('#custom_cartbtn').hide();
      selectSize = unique(selectSize);
      var product_data=[];
      selectSize.map(variantId => {
         if(jQuery('#qunatity-'+variantId).val()!=0){
          product_data.push({quantity:jQuery('#qunatity-'+variantId).val(), id: variantId})
         }
      });
      var counterDhoti=0;
      selectSize.map(variantId => {
        if(jQuery('#dhotiqunatity-'+variantId).val()!=0){
          var dhotivariantId = jQuery('#dhotiqunatity-'+variantId).attr('dhoti-variant');
          //product_data.push({quantity:jQuery('#dhotiqunatity-'+variantId).val(), id: dhotivariantId});
          product_data.push({quantity:jQuery('#dhotiqunatity-'+variantId).val(), id: variantId});
          counterDhoti+=parseInt(jQuery('#dhotiqunatity-'+variantId).val());
        }
      });
      var dhotiVarinatIds = jQuery('[name="dhotiqunatity"]').attr('dhoti-variant');
      if(dhotiVarinatIds!=""){
        product_data.push({quantity:counterDhoti, id: dhotiVarinatIds});
      }
      console.log(product_data);
      setTimeout(function(){
        var dataaa = {
          items: product_data
        };
        $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json',
          data:dataaa,
          success: function(data) {
             document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
               bubbles: true
             }));
             jQuery('.QuantitySelector__CurrentQuantity').val(0);
             selectSize=[];
             jQuery('.loading').hide();
             jQuery('#custom_cartbtn').show();
             jQuery('.total-size-amt').text('Rs .0');
             jQuery('.total-dhoti-amt').text('Rs .0');
             setTimeout(function(){
               $('html').addClass('no-scroll');
               jQuery('.PageOverlay').addClass('is-visible');
               jQuery('#sidebar-cart').attr('aria-hidden','false');
               jQuery('#sidebar-cart').attr('tab-index','-1');  
            },300);
          },
          error:function(errors) {
            console.log(errors);
            alert(errors.responseJSON.description);
            jQuery('.loading').hide();
             jQuery('#custom_cartbtn').show();
          }
        });
      },1500);
    }else{
      alert("Please add one qunatity of any variation");
    }
});
jQuery('#sidebar-cart .Drawer__Header--bordered').click(function(e) {
   jQuery('html').removeClass('no-scroll');
   jQuery(".js-drawer-close").trigger("click");
   jQuery('.PageOverlay').removeClass('is-visible');
   jQuery('#sidebar-cart').attr('aria-hidden','true');
   jQuery('#sidebar-cart').removeAttr('tab-index');
})

let variantCombo=[];
jQuery(document).on("change",".SizeSwatch__combo_Radio",function(){
  selectedVariantData();
});
let priceVariant=0;
let cpriceVariant=0;
function selectedVariantData(){
  variantCombo=[];
  priceVariant=0;
  cpriceVariant=0;
  jQuery('.SizeSwatch__combo_Radio:checked').each(function() {
      var variantId = jQuery(this).attr('data-variant-id');
      if(jQuery(this).attr('data-price')!=""){
        var price = parseFloat(jQuery(this).attr('data-price'));
        priceVariant+=price;
      }
      if(jQuery(this).attr('data-cprice')!=""){
        var cprice = parseFloat(jQuery(this).attr('data-cprice'));
        cpriceVariant+=cprice;
      }
      if (!variantExists(variantCombo, variantId)) {
          variantCombo.push({
            variant_id:variantId,
            quantity:1
          });
      }else{
        for(var r = 0; r < variantCombo.length; r++) {
            if (variantCombo[r] !== undefined && variantCombo[r].variant_id === variantId) {
                variantCombo[r].quantity+=1;
                break; // Exit loop after updating the quantity
            }
        }
      }
  });
  priceVariant=customMoney(priceVariant,window.theme.moneyFormat);
  cpriceVariant=customMoney(cpriceVariant,window.theme.moneyFormat);
  jQuery('.ProductMeta__PriceList .Price--highlight').text(priceVariant);
  jQuery('.ProductMeta__PriceList .Price--compareAt').text(cpriceVariant);
  jQuery('.ProductForm__combo__AddToCart span').last().text(priceVariant);
}

function customMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || "${{amount}}";

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(
    number,
    precision,
    thousands,
    decimal
  ) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }

  var value = "";

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;

    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;

    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;

    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;

    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;

    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
  }

  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString
      .replace(placeholderRegex, value)
      .replace(",00", "");
  } else {
    return formatString
      .replace(placeholderRegex, value)
      .replace(".00", "");
  }
}
function updateAddMoreText() {
  $('.addmore-section').remove();
  $('.default-pair').last().prepend('<div class="action-buttons"><div class="addmore-section" title="Add More"><span class="text-addmore">Add Extra Shirt</span></div></div>');
  $('.pair-section').last().prepend('<div class="action-buttons"><div class="addmore-section" title="Add More"><span class="text-addmore">Add Extra Shirt</span></div></div>');
}
var count = 2;
$(document).ready(function() {
    // Function to update the Add More text to the last .pair-section
    
    // Initially set Add More text
    updateAddMoreText();

    // Add More button click handler
    $(document).on('click', '.text-addmore', function() {
      var $clone = $(this).closest('.ProductForm__combo__Variants').clone();
      $clone.find('input[type="radio"]').prop('checked', false);
      count++;
      var newcounte = 0
      $clone.find('input[type="radio"]').each(function() {
        var id = $(this).attr('id').split('-')[0] + '-' + count + '-' + newcounte;
        $(this).attr('id', id);
        $(this).attr('name', 'option-pair-' + count);
        $(this).siblings('label').attr('for', id);
        newcounte++;
      });

      $(this).closest('.ProductForm__combo__Variants').after($clone);
      updateAddMoreText();
      if ($clone.find('.remove-section').length == 0) {
        $clone.find('.addmore-section').after('<div class="remove-section"><span class="remove-addmore" title="Remove"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 72 72"><path d="M 32.5 9 C 28.364 9 25 12.364 25 16.5 L 25 18 L 17 18 C 14.791 18 13 19.791 13 22 C 13 24.209 14.791 26 17 26 L 17.232422 26 L 18.671875 51.916016 C 18.923875 56.449016 22.67875 60 27.21875 60 L 44.78125 60 C 49.32125 60 53.076125 56.449016 53.328125 51.916016 L 54.767578 26 L 55 26 C 57.209 26 59 24.209 59 22 C 59 19.791 57.209 18 55 18 L 47 18 L 47 16.5 C 47 12.364 43.636 9 39.5 9 L 32.5 9 z M 32.5 16 L 39.5 16 C 39.775 16 40 16.224 40 16.5 L 40 18 L 32 18 L 32 16.5 C 32 16.224 32.225 16 32.5 16 z M 24.242188 26 L 47.757812 26 L 46.339844 51.525391 C 46.292844 52.352391 45.60825 53 44.78125 53 L 27.21875 53 C 26.39175 53 25.707156 52.353344 25.660156 51.527344 L 24.242188 26 z M 36 28 C 34.896 28 34 28.896 34 30 L 34 47.923828 C 34 49.027828 34.896 49.923828 36 49.923828 C 37.104 49.923828 38 49.027828 38 47.923828 L 38 30 C 38 28.896 37.104 28 36 28 z M 29.392578 28.001953 C 28.288578 28.039953 27.424891 28.964359 27.462891 30.068359 L 28.087891 48.068359 C 28.125891 49.148359 29.012937 50 30.085938 50 C 30.108938 50 30.131297 49.999047 30.154297 49.998047 C 31.258297 49.960047 32.123937 49.035641 32.085938 47.931641 L 31.460938 29.931641 C 31.421938 28.827641 30.459578 27.979953 29.392578 28.001953 z M 42.607422 28.001953 C 41.519422 27.979953 40.577062 28.827641 40.539062 29.931641 L 39.914062 47.931641 C 39.876062 49.035641 40.741703 49.959047 41.845703 49.998047 C 41.868703 49.999047 41.891062 50 41.914062 50 C 42.986062 50 43.874109 49.148359 43.912109 48.068359 L 44.537109 30.068359 C 44.575109 28.964359 43.711422 28.040953 42.607422 28.001953 z"></path></svg></span></div>');
      }
    });

    // Remove button click handler
    $(document).on('click', '.remove-addmore', function() {
      $(this).closest('.ProductForm__combo__Variants').remove();
      updateAddMoreText();
      selectedVariantData();
    });
  });

function removeVariantId(arr, variantId) {
    var filteredArray = arr.filter(function(item) {
        return parseInt(item.variant_id) !== parseInt(variantId);
    });
    return filteredArray;
}
function variantExists(array, variantId) {
    return array.some(item => item.variant_id === variantId);
}

function resetAllData(){
   updateAddMoreText();
   variantCombo=[];
   jQuery('.remove-addmore').trigger('click');
   count=2;
   jQuery('.pair-section .SizeSwatch__combo_Radio:checked').each(function(){
     jQuery(this).prop("checked",false);
   });
   jQuery('.default-pair .SizeSwatch__combo_Radio:checked').each(function(){
     jQuery(this).prop("checked",false);
   });
   jQuery('.default-pair .SizeSwatch__combo_Radio').eq(0).prop("checked","checked");
   jQuery('.pair-section .SizeSwatch__combo_Radio').eq(0).prop("checked","checked");
   selectedVariantData();
}

jQuery('.ProductForm__combo__AddToCart').on('click', function(e){
  if(variantCombo.length>0){
    jQuery('.loading').show();
    var itemArr=[];
    for(var d=0;d<variantCombo.length;d++){
        itemArr.push({
            id: variantCombo[d].variant_id,
            quantity: variantCombo[d].quantity,
        });
    }
    if(itemArr.length>0){
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: {items:itemArr},
        success(res) {
          //window.location="/checkout";
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
             bubbles: true
           }));
           setTimeout(function(){
             $('html').addClass('no-scroll');
             jQuery('.PageOverlay').addClass('is-visible');
             jQuery('#sidebar-cart').attr('aria-hidden','false');
             jQuery('#sidebar-cart').attr('tab-index','-1');
             resetAllData();
          },300);
        },
        error(XMLHttpRequest) {

        },
      });
    }
  }
});

$(document).ready(function () {
    var mobile = '';
    $('#otpForm').submit(function (e) {
        mobile = $('#mobile').val();
        e.preventDefault();
        $('#nameError, #mobileError').text('').hide();
        //$(".loading").show();

        $.ajax({
            url: 'https://blueisland.co.in/add-feed',
            method: 'POST',
            dataType: "json",
            data: {
                name: $('#name').val(),
                mobile: $('#mobile').val()
            },
            success: function (res) {
                if(res.status == true){
                    $(".loading").hide();
                    if(res.account_create == 1){
                        $('#qrcodesection').show();
                        $('#qrcode').html(res.qr);
                        $('#otpForm').hide();
                    }else{
                        $('#sendOtpBtn').hide();
                        $('#otpSection').show();
                        alert(res.message);
                    }
                }
            }
        });
    });

    $('#verifyOtpBtn').click(function () {
        $('#otpError').text('').hide();
        //$(".loading").show();
        $.ajax({
            url: 'https://blueisland.co.in/otp-verify',
            method: 'POST',
            dataType: "json",
            data: {
                name: $('#name').val(),
                mobile: $('#mobile').val(),
                otp: $('#otp').val()
            },
            success: function (res) {
                $(".loading").hide();
                alert('OTP Verified Successfully!');
                $('#qrcodesection').show();
                $('#qrcode').html(res.qr);
                $('#otpForm').hide();
            },
            error: function (xhr) {
                $(".loading").hide();
                if (xhr.status === 422) {
                    let errors = xhr.responseJSON.errors;
                    if (errors.otp) {
                        $('#otpError').text(errors.otp[0]).show();
                        $('#otp').addClass('is-invalid');
                    }
                } else {
                    alert('Invalid OTP or Expired.');
                }
            }
        });
    });

    setInterval(function(){
      if(mobile !== ''){
          $.ajax({
              url: 'https://blueisland.co.in/check-qrscan',
              method: 'POST',
              dataType: "json",
              data: {
                  mobile: mobile,
              },
              success: function (res) {
                  if(res.redirect_url == 1){
                      window.location.href = window.location.origin+'/'+'/collections/stain-proofs-shirts';
                      mobile = '';
                      // Do something on success
                  }
              }
          });
      }
  }, 2000); 
  
});
